
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import React from 'react'



class UserLookupChip extends React.Component {


  render() {
    const { user,onUserDeleted } = this.props;
    const { bun,name,displayName } = user;
    return (

       <Chip
              avatar={bun ? <Avatar src={`/api/users/userImage?bun=${bun.toLowerCase()}`}/> : null}
              onDelete={onUserDeleted ? () => onUserDeleted(user) : null}
              className="chip"
              label={name ? name : displayName}
              variant="outlined"
        />
       
    );
  }
}

export default UserLookupChip;
